export default __webpack_public_path__ + "static/media/ailogo.beb1b1ab.png";